export default class Section{
  constructor(info) {
    this.key = info.key;
    this.ele = info.ele;
    this.motionType = info.motionType;
    if(this.key == 'legend') {
      this.bgEfMotion = new TimelineMax({paused: false, repeat:-1});
      this._bgEffectSet();
    }
  }

  _bgEffectSet(){
    this.bgEfMotion
      .fromTo(this.ele.querySelector('.bg > span'), 0.3, {autoAlpha:0}, {autoAlpha:0.5, ease:Bounce.easeIn})
      .fromTo(this.ele.querySelector('.bg > span'), 0.3, {autoAlpha:0.5}, {autoAlpha:0, ease:Bounce.easeOut})
      .to(this.ele.querySelector('.bg > span'), 1, {autoAlpha:0})
      .fromTo(this.ele.querySelector('.bg > span'), 1, {autoAlpha:0}, {autoAlpha:0.2, ease:Quart.easeOut})
      .fromTo(this.ele.querySelector('.bg > span'), 1, {autoAlpha:0.2}, {autoAlpha:0, ease:Quart.easeIn})
      .to(this.ele.querySelector('.bg > span'), 1, {autoAlpha:0})
      .fromTo(this.ele.querySelector('.bg > span'), 1, {autoAlpha:0}, {autoAlpha:0.6, ease:Elastic.easeIn})
      .fromTo(this.ele.querySelector('.bg > span'), 1, {autoAlpha:0.6}, {autoAlpha:0, ease:Elastic.easeOut})
      .to(this.ele.querySelector('.bg > span'), 1, {autoAlpha:0})
      .fromTo(this.ele.querySelector('.bg > span'), 0.5, {autoAlpha:0}, {autoAlpha:0.3, ease:Quart.easeOut})
      .fromTo(this.ele.querySelector('.bg > span'), 0.5, {autoAlpha:0.3}, {autoAlpha:0, ease:Quart.easeIn})
      .to(this.ele.querySelector('.bg > span'), 1, {autoAlpha:0})
  }
  show(size, dx){
    let startPos = {x:0, y:0}
    if(size){
      if(this.motionType == 'vertical'){
        startPos.y = size.height * dx;
      }else if(this.motionType == 'horizontal'){
        startPos.x = size.width * dx;
      }
    }
    TweenLite.set(this.ele, {css:{className:'+=show'}});
    TweenLite.fromTo(this.ele, 0.7, startPos, {x:0, y:0, ease:Cubic.easeOut});
  }
  hide(size, dx){
    let endPos = {x:0, y:0, onComplete: this._hidetComplete, onCompleteParams: [this]}
    if(size){
      if(this.motionType == 'vertical'){
        endPos.y = size.height * dx;
      }else if(this.motionType == 'horizontal'){
        endPos.x = size.width * dx;
      }
    }
    TweenLite.set(this.ele, {css:{className:'-=show'}});
    TweenLite.set(this.ele, {css:{className:'+=hide'}});

    TweenLite.fromTo(this.ele, 0.7, {x:0, y:0}, endPos);
  }
  _hidetComplete(thisv) {
    TweenLite.set(thisv.ele, {css:{className:'-=hide'}});
  }
  move(id, isMovie){
    TweenMax.to(this.ele.querySelector('.bg'), isMovie, {x:(id*10)*-1+'%'})

  }
}



// WEBPACK FOOTER //
// ./src/js/page/section.js